import { stringifyQuery } from "ufo";

// eslint-disable-next-line
// @ts-ignore
import type { Info } from "+react-router-types/api.get-room-url";
import type { ParsedAuthCookieData } from "~/routes/api.auth.me";
import type { AuthResponse } from "~/shared/utils/auth-poker-sdk/auth-poker-sdk";

export class SiteSdk {
  /**
   * @deprecated
   * используйте getRoomUrlV2
   */
  public async getRoomUrl(
    locale: string,
    page?: string,
  ): Promise<Info["loaderData"]> {
    const query = stringifyQuery({ locale, page });

    const response = await fetch(`/api/get-room-url?${query}`, {
      method: "GET",
    });

    return response.json();
  }

  public async getRoomUrlV2(
    params: Record<string, string> & { locale: string },
  ): Promise<Info["loaderData"]> {
    const query = stringifyQuery(params);

    const response = await fetch(`/api/get-room-url-v2?${query}`, {
      method: "GET",
    });

    return response.json();
  }

  public async setAuthCookie(data: AuthResponse): Promise<void> {
    await fetch(`/api/set-auth-token`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  public async getParsedRoomUrlFromTemplate({
    template,
    locale,
  }: {
    template: string;
    locale: string;
  }): Promise<{ redirectUrl: string }> {
    const query = stringifyQuery({ locale, template });
    const response = await fetch(`/api/parse-template/get-room-url?${query}`, {
      method: "GET",
    });

    return response.json();
  }

  public async getUserAuthData(): Promise<ParsedAuthCookieData> {
    const authRes = await fetch("/api/auth/me");
    return authRes.json();
  }
}
